/* @file 资源管理-用户管理 */
<template>
  <div id="passenger">
    <!-- 搜索区 -->
    <div class="um-search-bar">
      <el-input v-model="query.phone" placeholder="手机号码" clearable size="small" style="width:160px" @keyup.enter.native="loadList(true)" />
      <el-input v-model="query.realName" placeholder="真实姓名" clearable size="small" style="width:130px" />
      <el-input v-model="query.idCard" placeholder="身份证号" clearable size="small" style="width:180px" />
      <el-select v-model="query.channel" placeholder="注册渠道" clearable size="small" style="width:120px">
        <el-option :value="1" label="乘客端" />
        <el-option :value="2" label="后台" />
        <el-option :value="3" label="司机端" />
      </el-select>
      <el-select v-model="query.status" placeholder="用户状态" clearable size="small" style="width:110px">
        <el-option :value="1" label="正常" />
        <el-option :value="2" label="禁用" />
      </el-select>
      <el-select v-model="query.isRealName" placeholder="实名状态" clearable size="small" style="width:110px">
        <el-option value="1" label="已实名" />
        <el-option value="2" label="未实名" />
      </el-select>
      <el-select v-model="query.businessType" placeholder="业务类型" clearable size="small" style="width:120px">
        <el-option value="bus" label="班车" />
        <el-option value="hitch_ride" label="顺风车" />
        <el-option value="station" label="客运站" />
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="loadList(true)">搜索</el-button>
      <el-button size="small" @click="resetQuery">重置</el-button>
    </div>

    <!-- 统计卡片 -->
    <div class="um-stat-row" v-if="stats.total !== null">
      <div class="stat-card">
        <div class="stat-num">{{ stats.total }}</div>
        <div class="stat-label">总用户数</div>
      </div>
      <div class="stat-card warn">
        <div class="stat-num">{{ stats.disabled }}</div>
        <div class="stat-label">禁用用户</div>
      </div>
      <div class="stat-card success">
        <div class="stat-num">{{ stats.realNamed }}</div>
        <div class="stat-label">已实名</div>
      </div>
      <div class="stat-card info">
        <div class="stat-num">{{ stats.hitchRide }}</div>
        <div class="stat-label">顺风车用户</div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table :data="list" v-loading="loading" size="small" border stripe style="width:100%" @row-click="openDetail">
      <el-table-column label="用户" width="180" fixed>
        <template slot-scope="{ row }">
          <div class="user-cell">
            <div class="user-avatar" :class="row.status === 2 ? 'disabled' : ''">
              {{ (row.realName || row.name || row.phone || '?')[0].toUpperCase() }}
            </div>
            <div class="user-info">
              <div class="user-name">{{ row.realName || row.name || '未实名' }}</div>
              <div class="user-phone">{{ row.phone }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 2 ? 'danger' : 'success'" size="mini">
            {{ row.status === 2 ? '禁用' : '正常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="实名" width="80">
        <template slot-scope="{ row }">
          <el-tag :type="row.isRealName === 1 ? 'success' : 'info'" size="mini">
            {{ row.isRealName === 1 ? '已实名' : '未实名' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="业务类型" min-width="150">
        <template slot-scope="{ row }">
          <span v-if="!row.businessType || row.businessType === ''">-</span>
          <span v-else style="display:flex;flex-wrap:wrap;gap:2px">
            <el-tag v-if="row.businessType.includes('bus')" size="mini" type="primary">班车</el-tag>
            <el-tag v-if="row.businessType.includes('hitch_ride')" size="mini" type="warning">顺风车</el-tag>
            <el-tag v-if="row.businessType.includes('station')" size="mini" type="info">客运站</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="班车订单" prop="busOrderCount" width="90" align="center">
        <template slot-scope="{ row }">{{ row.busOrderCount || 0 }}</template>
      </el-table-column>
      <el-table-column label="顺风车订单" prop="hitchRideOrderCount" width="100" align="center">
        <template slot-scope="{ row }">{{ row.hitchRideOrderCount || 0 }}</template>
      </el-table-column>
      <el-table-column label="累计消费" width="100" align="right">
        <template slot-scope="{ row }">
          <span class="money-text" v-if="row.totalAmount">¥{{ row.totalAmount }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="注册渠道" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.channel === 1" size="mini" type="success">乘客端</el-tag>
          <el-tag v-else-if="row.channel === 2" size="mini" type="primary">后台</el-tag>
          <el-tag v-else-if="row.channel === 3" size="mini" type="warning">司机端</el-tag>
          <el-tag v-else-if="row.channel === 4" size="mini" type="info">接口</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="最近下单" min-width="110">
        <template slot-scope="{ row }">
          <span style="white-space:nowrap">{{ row.lastOrderTime ? $utils.timeFn(row.lastOrderTime * 1000, 'YYYY/MM/DD') : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="注册时间" min-width="155">
        <template slot-scope="{ row }">
          <span style="white-space:nowrap">{{ row.created | filterTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right" @click.stop="">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click.stop="openDetail(row)">详情</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button
            type="text" size="mini"
            :class="row.status === 2 ? 'btn-enable' : 'btn-disable'"
            @click.stop="toggleStatus(row)"
          >{{ row.status === 2 ? '启用' : '禁用' }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="um-pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="total"
        :page-size.sync="query.pageSize"
        :current-page.sync="query.pageNum"
        :page-sizes="[20, 50, 100]"
        @current-change="loadList(false)"
        @size-change="loadList(true)"
      />
    </div>

    <!-- 禁用弹窗 -->
    <el-dialog title="禁用用户" :visible.sync="disableDialog.visible" width="420px" @close="disableDialog.reason = ''">
      <el-form label-width="80px">
        <el-form-item label="禁用原因">
          <el-input v-model="disableDialog.reason" type="textarea" :rows="3" placeholder="请填写禁用原因（将向用户显示）" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="disableDialog.visible = false">取消</el-button>
        <el-button type="danger" :loading="disableDialog.loading" @click="confirmDisable">确认禁用</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情抽屉 -->
    <el-drawer
      :title="detailData ? (detailData.realName || detailData.name || detailData.phone || '用户详情') : '用户详情'"
      :visible.sync="detailDrawer"
      size="620px"
      @open="loadDetailOrders"
    >
      <div v-if="detailData" class="detail-wrap">
        <!-- 基本信息 -->
        <div class="detail-section">
          <div class="detail-avatar">
            {{ (detailData.realName || detailData.name || detailData.phone || '?')[0].toUpperCase() }}
          </div>
          <div class="detail-basic">
            <div class="detail-name">{{ detailData.realName || detailData.name || '未实名' }}</div>
            <div class="detail-phone">{{ detailData.phone }}</div>
            <div style="margin-top:8px">
              <el-tag :type="detailData.status === 2 ? 'danger' : 'success'" size="small" style="margin-right:6px">
                {{ detailData.status === 2 ? '禁用' : '正常' }}
              </el-tag>
              <el-tag :type="detailData.isRealName === 1 ? 'success' : 'info'" size="small">
                {{ detailData.isRealName === 1 ? '已实名' : '未实名' }}
              </el-tag>
            </div>
          </div>
          <div class="detail-actions">
            <el-button
              :type="detailData.status === 2 ? 'success' : 'danger'"
              size="small"
              @click="toggleStatus(detailData)"
            >{{ detailData.status === 2 ? '启用账号' : '禁用账号' }}</el-button>
          </div>
        </div>

        <el-divider></el-divider>

        <!-- 统计 -->
        <el-row :gutter="16" class="detail-stats">
          <el-col :span="6">
            <div class="ds-item">
              <div class="ds-val">{{ detailData.busOrderCount || 0 }}</div>
              <div class="ds-lab">班车订单</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="ds-item">
              <div class="ds-val">{{ detailData.hitchRideOrderCount || 0 }}</div>
              <div class="ds-lab">顺风车订单</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="ds-item">
              <div class="ds-val">¥{{ detailData.totalAmount || '0.00' }}</div>
              <div class="ds-lab">累计消费</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="ds-item">
              <div class="ds-val">{{ detailData.lastOrderTime ? $utils.timeFn(detailData.lastOrderTime * 1000, 'MM/DD') : '-' }}</div>
              <div class="ds-lab">最近下单</div>
            </div>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <!-- 订单Tabs -->
        <el-tabs v-model="detailTab">
          <el-tab-pane label="班车订单" name="bus">
            <div class="detail-order-list" v-loading="detailLoading.bus">
              <div v-if="busOrders.length === 0 && !detailLoading.bus" class="empty-tip">暂无班车订单</div>
              <div v-for="o in busOrders" :key="o.id" class="order-card">
                <div class="oc-left">
                  <div class="oc-no">{{ o.orderNo }}</div>
                  <div class="oc-info">{{ o.customerName || '-' }} · {{ o.passengerNum || 1 }}人</div>
                </div>
                <div class="oc-right">
                  <div class="oc-fee">¥{{ o.realFee || o.orderFee || '-' }}</div>
                  <div class="oc-time">{{ o.created | filterTime }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="顺风车订单" name="hitchRide">
            <div class="detail-order-list" v-loading="detailLoading.hitchRide">
              <div v-if="hitchRideOrders.length === 0 && !detailLoading.hitchRide" class="empty-tip">暂无顺风车订单</div>
              <div v-for="o in hitchRideOrders" :key="o.id" class="order-card">
                <div class="oc-left">
                  <div class="oc-no">{{ o.orderNo }}</div>
                  <div class="oc-route">{{ o.startPointName }} → {{ o.endPointName }}</div>
                  <div class="oc-info">{{ o.passengerNum }}人 · {{ o.poolType === 1 ? '独享' : '拼车' }}</div>
                </div>
                <div class="oc-right">
                  <div class="oc-fee">¥{{ o.amount ? (o.amount / 100).toFixed(2) : '-' }}</div>
                  <div class="oc-time">{{ o.created | filterTime }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'passenger',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      stats: { total: null, disabled: 0, realNamed: 0, hitchRide: 0 },
      query: {
        pageNum: 1,
        pageSize: 20,
        phone: '',
        realName: '',
        idCard: '',
        channel: '',
        status: '',
        isRealName: '',
        businessType: '',
      },
      // 禁用弹窗
      disableDialog: { visible: false, loading: false, reason: '', row: null },
      // 详情抽屉
      detailDrawer: false,
      detailData: null,
      detailTab: 'bus',
      detailLoading: { bus: false, hitchRide: false },
      busOrders: [],
      hitchRideOrders: [],
    };
  },
  created() {
    this.loadList(true);
  },
  methods: {
    async loadList(resetPage) {
      if (resetPage) this.query.pageNum = 1;
      this.loading = true;
      try {
        const res = await this.$axios.get('/api/v1/manage/customer', {
          ...this.query,
          page: this.query.pageNum,
          size: this.query.pageSize,
        });
        if (res && res.code === 1) {
          this.list = res.data || [];
          this.total = res.count || 0;
          if (this.stats.total === null) {
            this.stats.total = res.count || 0;
            this.stats.disabled = this.list.filter(r => r.status === 2).length;
            this.stats.realNamed = this.list.filter(r => r.isRealName === 1).length;
            this.stats.hitchRide = this.list.filter(r => r.businessType && r.businessType.includes('hitch_ride')).length;
          }
        }
      } finally {
        this.loading = false;
      }
    },

    resetQuery() {
      Object.assign(this.query, { phone: '', realName: '', idCard: '', channel: '', status: '', isRealName: '', businessType: '' });
      this.stats.total = null;
      this.loadList(true);
    },

    openDetail(row) {
      this.detailData = { ...row };
      this.detailTab = 'bus';
      this.busOrders = [];
      this.hitchRideOrders = [];
      this.detailDrawer = true;
    },

    async loadDetailOrders() {
      if (!this.detailData) return;
      const id = this.detailData.id;
      this.detailLoading.bus = true;
      this.detailLoading.hitchRide = true;
      try {
        const [busRes, hrRes] = await Promise.all([
          this.$axios.get(`/api/v1/manage/customer/${id}/bus-orders`, { pageNum: 1, pageSize: 20 }),
          this.$axios.get(`/api/v1/manage/customer/${id}/hitch-ride-orders`, { pageNum: 1, pageSize: 20 }),
        ]);
        if (busRes && busRes.code === 1) {
          this.busOrders = (busRes.data && busRes.data.records) || [];
        }
        if (hrRes && hrRes.code === 1) {
          this.hitchRideOrders = (hrRes.data && hrRes.data.records) || [];
        }
      } finally {
        this.detailLoading.bus = false;
        this.detailLoading.hitchRide = false;
      }
    },

    toggleStatus(row) {
      if (row.status !== 2) {
        this.disableDialog.row = row;
        this.disableDialog.reason = '';
        this.disableDialog.visible = true;
      } else {
        this.$confirm('确认启用该用户账号？', '提示', { type: 'warning' }).then(async () => {
          await this.doUpdateStatus(row, 1, '');
        }).catch(() => {});
      }
    },

    async confirmDisable() {
      const row = this.disableDialog.row;
      if (!row) return;
      this.disableDialog.loading = true;
      await this.doUpdateStatus(row, 2, this.disableDialog.reason);
      this.disableDialog.loading = false;
      this.disableDialog.visible = false;
    },

    async doUpdateStatus(row, status, reason) {
      let url = `/api/v1/manage/customer/${row.id}/status?status=${status}`;
      if (status === 2 && reason) url += `&disableReason=${encodeURIComponent(reason)}`;
      const res = await this.$axios.put(url, {});
      if (res && res.code === 1) {
        this.$message.success(status === 1 ? '已启用' : '已禁用');
        row.status = status;
        row.disableReason = reason || null;
        if (this.detailData && this.detailData.id === row.id) {
          this.detailData.status = status;
        }
        this.loadList(false);
      } else {
        this.$message.error((res && res.message) || '操作失败');
      }
    },
  },
};
</script>

<style lang="less">
#passenger {
  padding: 16px;
  box-sizing: border-box;

  .um-search-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
    align-items: center;
  }

  .um-stat-row {
    display: flex;
    gap: 12px;
    margin-bottom: 14px;
    .stat-card {
      flex: 1;
      background: #f0f7ff;
      border: 1px solid #d0e8ff;
      border-radius: 8px;
      padding: 10px 16px;
      text-align: center;
      .stat-num { font-size: 22px; font-weight: 700; color: #409eff; }
      .stat-label { font-size: 12px; color: #909399; margin-top: 2px; }
      &.warn { background: #fff8f0; border-color: #ffd8a8;
        .stat-num { color: #e6a23c; }
      }
      &.success { background: #f0fff4; border-color: #b7e5c7;
        .stat-num { color: #67c23a; }
      }
      &.info { background: #f4f4f5; border-color: #d3d4d6;
        .stat-num { color: #606266; }
      }
    }
  }

  .user-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    .user-avatar {
      width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
      background: linear-gradient(135deg, #409eff, #66b1ff);
      color: #fff; font-size: 14px; font-weight: 700;
      display: flex; align-items: center; justify-content: center;
      &.disabled { background: #c0c4cc; }
    }
    .user-info {
      .user-name { font-size: 13px; font-weight: 600; color: #303133; }
      .user-phone { font-size: 12px; color: #909399; }
    }
  }

  .money-text { font-weight: 600; color: #e6a23c; }
  .btn-disable { color: #f56c6c !important; }
  .btn-enable { color: #67c23a !important; }

  .um-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 14px;
  }

  /* 用户详情抽屉 */
  .detail-wrap {
    padding: 0 20px 20px;

    .detail-section {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      padding: 16px 0;
      .detail-avatar {
        width: 56px; height: 56px; border-radius: 50%;
        background: linear-gradient(135deg, #409eff, #66b1ff);
        color: #fff; font-size: 22px; font-weight: 700;
        display: flex; align-items: center; justify-content: center;
        flex-shrink: 0;
      }
      .detail-basic { flex: 1;
        .detail-name { font-size: 18px; font-weight: 700; color: #303133; }
        .detail-phone { font-size: 14px; color: #909399; margin-top: 2px; }
      }
    }

    .detail-stats {
      .ds-item {
        text-align: center;
        .ds-val { font-size: 18px; font-weight: 700; color: #303133; }
        .ds-lab { font-size: 12px; color: #909399; margin-top: 2px; }
      }
    }

    .detail-order-list {
      max-height: 320px;
      overflow-y: auto;
      .empty-tip { text-align: center; color: #c0c4cc; padding: 30px 0; font-size: 13px; }
      .order-card {
        display: flex;
        justify-content: space-between;
        padding: 10px 12px;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        margin-bottom: 8px;
        background: #fafafa;
        &:hover { background: #f0f7ff; border-color: #d0e8ff; }
        .oc-no { font-size: 13px; font-weight: 600; color: #303133; }
        .oc-route { font-size: 12px; color: #606266; margin-top: 2px; }
        .oc-info { font-size: 12px; color: #909399; margin-top: 2px; }
        .oc-right { text-align: right;
          .oc-fee { font-size: 14px; font-weight: 700; color: #e6a23c; }
          .oc-time { font-size: 12px; color: #c0c4cc; margin-top: 4px; }
        }
      }
    }
  }
}
</style>
